import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useAcessoSoftwares } from '../config/softwares';

// Rotas /softwares: abrem para quem a API deixa ver a página (config/softwares.js). A equipe
// Exxer sempre; o cliente só com algum software liberado pelo admin. Os outros voltam à Home.
const SoftwaresRoute = () => {
  const { usuario } = useAuth();
  const { carregando, visivel } = useAcessoSoftwares(usuario);

  if (!usuario || carregando) return null;
  if (!visivel) return <Navigate to="/home" />;
  return <Outlet />;
};

export default SoftwaresRoute;
